// NewsDetailPage.jsx
import { useParams, useLocation } from "react-router-dom";
import moment from "moment";

const NewsPage = () => {
  const { id } = useParams();
  const location = useLocation();

  // Get news item from navigation state
  const { newsItem, language } = location.state || {};

  // Fallback: If no state (direct URL access), you might want to fetch
  // or redirect, or show loading state
  if (!newsItem) {
    // Option 1: Redirect back
    // navigate('/');

    // Option 2: Fetch from API/context
    // const [item, setItem] = useState(null);
    // useEffect(() => { fetchNewsItem(id) }, [id]);

    return (
      <div
        className="min-h-screen flex items-center justify-center"
        style={{ marginTop: "10rem" }}
      >
        <div className="text-center">
          <p className="text-gray-600">Loading news item...</p>
          <button
            onClick={() => window.history.back()}
            className="mt-4 text-green-600"
          >
            Go Back
          </button>
        </div>
      </div>
    );
  }

  return (
    <div
      className="min-h-screen bg-gray-50 py-8"
      
    >
      <div className="max-w-4xl mx-auto bg-white rounded-xl shadow-lg p-8" style={{ marginTop: "10rem" }}>
        <button
          onClick={() => window.history.back()}
          className="mb-6 text-green-600 hover:text-green-700 flex items-center"
        >
          ← {language === "ar" ? "العودة" : "Back"}
        </button>

        <h1 className="text-3xl font-bold text-green-900 mb-4">
          {language === "ar" ? newsItem.title_ar : newsItem.title}
        </h1>

        <div className="text-gray-500 mb-6">
          <span className="text-sm">
            {moment(newsItem.date).format("YYYY-MM-DD")}
          </span>
        </div>

        <div className="prose max-w-none text-gray-700">
          <p className="whitespace-pre-line">
            {language === "ar" ? newsItem.body_ar : newsItem.body}
          </p>
        </div>
      </div>
    </div>
  );
};

export default NewsPage;
